export const infoMenus = [
    {path: '/'          , title: '다주소란?'},
    {path: '/cinfo'     , title: '다주소 등기부등본 처리'},
    {path: '/binfo'     , title: '다주소 대장 처리'},
    // {path: '/pinfo'     , title: '다주소 (아파트/주택/토지) 가격정보'},
    {path: '/custom'    , title: '고객맞춤형리포트'},
    {path: '/price'     , title: '서비스 가격'},
    {path: '/estimate'  , title: '견적문의'},
]